import { ExposedReadUserDetailsRes } from 'app/interfaces/responses/Exposed/exposedReadUserDetailsRes';

export function CheckReportAccess(userDetails: ExposedReadUserDetailsRes, reportKey: string): boolean {
    return userDetails.reports.findIndex((r) => r.reportKey == reportKey) > -1;
}
